export const getters = {
  productRecommendationList: ({ productRecommendationList }) => productRecommendationList,
};
